import React from 'react';
import './stocktag.scss';

export const PRE_ORDER = 'PRE_ORDER';

// Items without an availability set are treated as in stock.
export const stockLabel = (item) => (item?.availability === PRE_ORDER ? 'Pre-Order' : 'In Stock');

const StockTag = ({ item }) => {
  const preOrder = item?.availability === PRE_ORDER;
  return (
    <span className={`stock-tag ${preOrder ? 'stock-tag--pre-order' : 'stock-tag--in-stock'}`}>
      {stockLabel(item)}
    </span>
  );
};

export default StockTag;
